import styled from '@emotion/styled'

import { palette, spacing } from 'main/ui'

export const Container = styled.div`
  align-items: start;
  display: flex;
  flex-direction: row;

  > * {
    margin-right: ${spacing.majorScale(1)}px;
    vertical-align: text-top;
  }
`

export const IconContainer = styled.div`
  display: inline-flex;
  color: ${palette.slate};
  margin: ${spacing.minorScale(1)}px ${spacing.majorScale(3)}px 0 0;
  width: 24px;
`

export const ContentContainer = styled.div`
  display: inline-grid;
`
